<template>
	<inertia-head title="BCC Content Management" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">BCC Content Management</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Block Chain Circle</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="text-end mb-4">
			<button @click="viewBccContentModal(0,'add')" class="btn btn-alt-primary">
				<i class="fa fa-plus me-1"></i>
				Add Content
			</button>
		</div>
		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title"></div>
				<div class="block-options">
					<div class="input-group">
						<div class="input-group-prepend"><span class="input-group-text">Filter By Category</span></div>
						<select v-model="filter" class="form-select">
							<option value="null">All</option>
							<option v-for="(row) in categories" :value="row.category">{{row.category}}</option>
						</select>
					</div>
				</div>
			</div>
			<div class="block-content block-content-full">
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead>
							<tr>
								<th>CATEGORY</th>
								<th>PUBLISH BY</th>
								<th>TITLE</th>
								<th>VIMEO ID</th>
								<th>DATE START</th>
								<th>CREATED</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(content, c_index) in contents.data"
								:key="content.sub_content_id"
							>
								<td>{{content.category}}</td>
								<td>{{content.publish_by}}</td>
								<td>{{content.title}}</td>
								<td>{{content.vimeo_id}}</td>
								<td>{{content.date_start}}</td>
								<td>{{content.created_at}}</td>
								<td class="text-end">
									<button @click="viewBccContentModal(c_index,'update')" type="button" class="btn btn-sm btn-alt-info"><i class="fa fa-pencil-alt"></i></button>
								</td>
							</tr>
							<tr v-if="contents.data.length <= 0">
								<td colspan="7" class="mb-0 fw-semibold text-center p-5">NO BCC CONTENT FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="contents.data.length > 0" :collections="contents"/>
			</div>
		</div>
		<add-update-bcc-content ref="addUpdateBccContentModal" :content="selectedBccContent"/>
	</div>
</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
import AddUpdateBccContent from '../../Components/Admin/AddUpdateBccContent'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia';

export default {
	layout: AuthLayout,
	props: {
		categories	: Object,
		contents	: Object,
		filter 		: Object,
		api_response: Object
	},
	components:{AddUpdateBccContent},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const filter = ref(props.filter);

		const action = ref('add');

		const toast = createToaster();

		const selectedBccContent = reactive({});

		const addUpdateBccContentModal = ref(null);

		const viewBccContentModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedBccContent.sub_content_uuid 	= props.contents.data[_index].sub_content_uuid;
				selectedBccContent.category 			= props.contents.data[_index].category;
				selectedBccContent.title 				= props.contents.data[_index].title;
				selectedBccContent.vimeo_id 			= props.contents.data[_index].vimeo_id;
				selectedBccContent.description 			= props.contents.data[_index].description;
				selectedBccContent.publish_by 			= props.contents.data[_index].publish_by;
				selectedBccContent.date_start 			= props.contents.data[_index].date_start;
				selectedBccContent.status 				= props.contents.data[_index].status;
			}

			addUpdateBccContentModal.value.setBccContent(_action,selectedBccContent);

			addUpdateBccContentModal.value.toggleModal();

		}

		watch(filter, (value,old_value) => {
			
			if(value!=old_value)
			{
				var param = {filter:value}

				if(value=="null")
				{
					param = "";
				}

				Inertia.get(
						'/admin/bcc-content', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['contents', 'categories','filters']
						}
					)
			}
		})

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action=='add' ? 'added' : 'updated';

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "danger"});
				}
			}
		})

		return{
			filter,
			action,
			toast,
			viewBccContentModal,
			selectedBccContent,
			addUpdateBccContentModal
		}
	},
}
</script>
